<header id="headerContainer">
  <div class="header-container mobile-only">
    <div class="mobile-header">
      <img class="logo cb" src="assets/cb/images/CB_Icon_Rev.svg" alt="{{ config().title }} Logo">
      <div class="close-icon cb" (click)="toggleMenu.emit()"><img src="assets/cb/images/hamburger_menu_red.svg" alt="Menu"></div>
    </div>
  </div>
  <div class="web-tab-only header-container">
    <div class="logo-container">
      <a href="{{ config().marketingSite }}" target="_blank"><img src="{{ config().logo }}" alt="{{ config().title }} Logo"></a>
    </div>
    <div class="progress-bar-container">
      <app-nav-top></app-nav-top>
    </div>
    <div class="action-container cb">
      <div class="action-table">
        <div class="cart-container cb">
          <a [routerLink]="['/cart']">
            @if (cartEmpty()) {
              <img src="assets/cb/images/shopping_cart_empty.svg" alt="Cart">
            } @else {
              <img src="assets/cb/images/shopping_cart.png" alt="Cart">
            }
          </a>
        </div>
        @if (user() && rewardsEnabled) {
          <div class="login-container">
            <button class="color" (click)="redirect()">REWARDS</button>
          </div>
        }
        @if (user()) {
          <div class="login-container">
            @if (user()?.firstName) {
              <button class="grey" routerLink="/account">Hi, {{user()?.firstName}}</button>
            }
            @if (!user()?.firstName) {
              <button class="grey" routerLink="/account">{{user()?.username}}</button>
            }
          </div>
        }
        <div class="login-container">
          @if (!user()) {
            <button class="red" (click)="toggleLogin.emit()">LOGIN</button>
          }
          @if (user()) {
            <button class="red" (click)="toggleLogout.emit()">LOGOUT</button>
          }
        </div>
        <div class="hamburger-menu-container">
          @if (!navbarOpen()) {
            <button (click)="toggleMenu.emit()"><img src="assets/cb/images/hamburger-menu-icon.png"
            alt="Menu"></button>
          }
          @if (navbarOpen()) {
            <div class="close-button-container">
              <button (click)="toggleMenu.emit();"><img src="assets/cb/images/close_menu_icon.svg" alt="Close"></button>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
</header>
